module.exports = __webpack_public_path__ + "img/banner_left.6b41032b.jpg";